<script>
import BaseConfig from './base-config.vue';

export default {
  name: 'DIDBuyNow',
  extends: BaseConfig,
};
</script>
